/* ACTION TYPES */
export const SAVE_PROBLEM = 'SAVE_PROBLEM';
export const EDIT_PROBLEM = 'EDIT_PROBLEM';
export const EDIT_CHALLENGE = 'EDIT_CHALLENGE';
export const TAKE_CHALLENGE = 'TAKE_CHALLENGE';
export const SAVE_CHALLENGE = 'SAVE_CHALLENGE';
export const SAVE_JOB = 'SAVE_JOB';
export const SAVE_SKILLS = 'SAVE_SKILLS';
export const EDIT_JOB = 'EDIT_JOB';
export const GET_CHALLENGE_ID = 'GET_CHALLENGE_ID';
export const UPDATE_REMARKS_DATA_SOURCE = 'UPDATE_REMARKS_DATA_SOURCE';
export const GET_ALL_PROBLEM = 'GET_ALL_PROBLEM';
export const CLEAR_EDIT_PROBLEM = 'CLEAR_EDIT_PROBLEM';
export const CLEAR_EDIT_CHALLENGE = 'CLEAR_EDIT_CHALLENGE';
export const SAVE_TOKEN_OBJECT_TO_REDUX = 'SAVE_TOKEN_OBJECT_TO_REDUX';
export const CLICKED_TI_CHALLENGE = 'CLICKED_TI_CHALLENGE';

/* ACTION CREATORS */
export function saveProblemAction (payload) {
  return { type: SAVE_PROBLEM, payload };
}

export function editProblemAction (problem_id) {
  return { type: EDIT_PROBLEM, problem_id };
}

export function takeChallengeAction (challenge_id, step = null) {
  return { type: TAKE_CHALLENGE, challenge_id, step };
}

export function saveChallengeAction (payload) {
  return { type: SAVE_CHALLENGE, payload };
}

export function saveJobAction (payload) {
  return { type: SAVE_JOB, payload };
}

export function saveSkillsAction (payload) {
  return { type: SAVE_SKILLS, payload };
}

export function editJobAction (job_id) {
  return { type: EDIT_JOB, job_id };
}

export function editChallengeAction (challenge_id) {
  return { type: EDIT_CHALLENGE, challenge_id };
}

export function getChallengeId (challenge_id) {
  return { type: GET_CHALLENGE_ID, challenge_id };
}

export function updateRemarksDataSource (remarkDataSource) {
  return { type: UPDATE_REMARKS_DATA_SOURCE, remarkDataSource };
}

export function getProblemAction (payload) {
  return { type: GET_ALL_PROBLEM, payload };
}

export function clearEditProblemAction () {
  return { type: CLEAR_EDIT_PROBLEM };
}

export function clearEditChallengeAction () {
  return { type: CLEAR_EDIT_CHALLENGE };
}

export function saveUserTokenObject (payload) {
  return { type: SAVE_TOKEN_OBJECT_TO_REDUX, payload };
}

export function clickedChallengeCardAction (payload) {
  return { type: CLICKED_TI_CHALLENGE, payload };
};
